// extracted by mini-css-extract-plugin
export default {"customSize":"styles_customSize__QfYZJ","qlWrapper":"styles_qlWrapper__xeiRl"};